import { compact } from 'underscore';
import { overviewGridPickerConfig } from './overview-grid-picker-config';

/* global Map */
const toolbarItemsWithSelection = ({ onSelectCrossPage }) => [
  ['selection-widget', {
    type: 'selection-widget',
    onSelectCrossPage,
  }],
  ['divider', {
    type: 'divider',
  }],
  ['dropdown-edit', {
    id: 'dropdown-edit',
    type: 'dropdown',
  }],
  ['expander', {
    type: 'expander',
  }],
  ['button-clear-selection', {
    id: 'button-clear-selection',
    type: 'button-clear-selection',
  }],
];

const toolbarItemsNoSelection = ({ i18n, history, gridName }) => compact([
  ['grid-picker', overviewGridPickerConfig({ i18n, history, gridName })],
  ['predicate-list', {
    id: 'predicate-list',
    type: 'custom',
  }],
  ['expander', {
    type: 'expander',
  }],
  // fix bug 3660668:An unnamed input box appear after click the Download button
  // The grid toolbar that is not HotelidGrid or HotelGroupGrid does not display search-box-filter
  (gridName === 'HotelIdGrid' || gridName === 'HotelGroupGrid') && ['search-box-filter', {
    id: 'search-box-filter',
    type: 'search-box',
  }],
  ['dropdown-column-chooser', {
    id: 'dropdown-column-chooser',
    type: 'dropdown',
    pullRight: true,
  }],
  ['button-download', {
    id: 'button-download',
    type: 'nav-item',
    iconLeftGlyphName: 'ba-Download',
  }],
]);

export function getToolbarConfig({
  onSelectCrossPage, i18n, history, gridName,
}) {
  const toolbarSelectedConfig = new Map();

  toolbarItemsWithSelection({ i18n, onSelectCrossPage }).forEach(([key, value]) => {
    toolbarSelectedConfig.set(key, value);
  });

  const toolbarUnselectedConfig = new Map();

  toolbarItemsNoSelection({ i18n, history, gridName }).forEach(([key, value]) => {
    toolbarUnselectedConfig.set(key, value);
  });

  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
